<template>
  <section v-if="scenes.length" class="ni-slogan" id="slogan-carousel">
    <div class="ni-container">
      <div class="ni-slogan__frame">
        <CoreSwiper
          class="ni-slogan__swiper"
          :modules="modules"
          :slides-per-view="1"
          :loop="scenes.length > 1"
          :autoplay="autoplayConfig"
          :allow-touch-move="scenes.length > 1"
          :observer="true"
          :observe-parents="true"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <CoreSwiperSlide
            v-for="scene in scenes"
            :key="scene.id"
            class="ni-slogan__slide"
            @click="handleFrameClick(scene)"
          >
            <img
              :src="scene.imageUrl"
              alt="Qingdao Coastline Panoramic View"
            />
          </CoreSwiperSlide>
        </CoreSwiper>

        <div class="ni-slogan__overlay"></div>

        <div class="ni-slogan__watermark">
          <span class="ni-slogan__watermark-text">QINGDAO</span>
        </div>

        <div class="ni-slogan__content">
          <div class="ni-slogan__calligraphy">
            <span class="ni-slogan__calligraphy-prefix">{{ t('newIndex.sections.slogan.prefix') }}</span>
            <span class="ni-slogan__calligraphy-main">{{ t('newIndex.sections.slogan.main') }}</span>
          </div>
          <p class="ni-slogan__subtitle">{{ subSlogan }}</p>
        </div>

        <div class="ni-slogan__dots" role="tablist" :aria-label="t('newIndex.sections.slogan.carouselLabel')">
          <button
            v-for="(_, idx) in scenes"
            :key="idx"
            type="button"
            role="tab"
            class="ni-slogan__dot"
            :class="{ 'ni-slogan__dot--active': idx === currentIndex }"
            :aria-label="t('newIndex.sections.slogan.goToSlide', { n: idx + 1 })"
            :aria-selected="idx === currentIndex"
            @click.stop="goToSlide(idx)"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper as CoreSwiper, SwiperSlide as CoreSwiperSlide } from 'swiper/vue';
import { Autoplay } from 'swiper/modules';
import { useI18n } from 'vue-i18n';

export default {
  name: 'SloganSlider',
  components: {
    CoreSwiper,
    CoreSwiperSlide,
  },
  props: {
    scenes: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data() {
    return {
      currentIndex: 0,
      swiperInstance: null,
      modules: [Autoplay],
    };
  },
  computed: {
    currentScene() {
      if (!this.scenes.length) {
        return { id: '', imageUrl: '', subSlogan: '', url: '' };
      }
      return this.scenes[this.currentIndex] || this.scenes[0];
    },
    subSlogan() {
      return this.currentScene.subSlogan || '';
    },
    autoplayConfig() {
      if (this.scenes.length <= 1) return false;
      return {
        delay: 6000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      };
    },
  },
  watch: {
    scenes() {
      this.$nextTick(() => {
        if (!this.swiperInstance) return;
        this.swiperInstance.update();
        if (this.currentIndex >= this.scenes.length) {
          this.goToSlide(0);
        }
      });
    },
  },
  methods: {
    onSwiper(swiper) {
      this.swiperInstance = swiper;
    },
    onSlideChange(swiper) {
      this.currentIndex = swiper.realIndex;
    },
    goToSlide(idx) {
      if (!this.swiperInstance) return;
      if (this.scenes.length > 1) {
        this.swiperInstance.slideToLoop(idx);
      } else {
        this.swiperInstance.slideTo(idx);
      }
    },
    handleFrameClick(scene) {
      const url = scene?.url;
      if (url) {
        window.open(url, '_blank');
      }
    },
  },
};
</script>
